import React, { useEffect, useState, useRef } from "react";
import WeightGainCalculatorForm from "./WeightGain-Calculator-Form";
import WeightGainCalculatorResult from "./WeightGain-Calculator-Result/index.js";
import Loader from "./Loader/Loader.js";
import CONFIG_OBJECT from "../../config/config";
import { postDataFetcher } from "../../dataFetcher";
import App_Constants from "../../app-constants/App_Constants";
import { withTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import { Form, Button, FormControl } from "react-bootstrap";

import "./weightgain-calculator.css";

const WeightGainCalculator = (props) => {
    const { t } = props; //for dictionary phrases
    const [componentData, setComponentData] = useState();
    const [WeightGainCalculatorData, setWeightGainCalculatorData] = useState({
        showResult: false,
        apiData: {},
        loader: false,
        error: "",
    });
    const [showDesc, setShowDesc] = useState(isMobile ? false : true);
    const [showForm, setShowForm] = useState(true);
    const [showEditForm, setShowEditForm] = useState(false);

    let weightGainCalcData = {
        prePregnancyWeight: 0,
        weightUnit: "",
        weightId: "",
        currentWeek: 0,
        currentWeekId: "",
        isExpectingTwins: false,
    };

    // calling layout service and updating state with weightgain calculator api response
    useEffect(() => {
        setComponentData(props.fields);
        document.getElementById("btn-calculate").disabled = true;
    }, []);

    // useEffect(() => {
    //     console.log(componentData);
    // }, [componentData]);

    // scroll to element function
    const resultRef = useRef(null);
    const executeScroll = () => {
        resultRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }

    const showMainMenu = () => {
        setShowForm(true);
        setShowEditForm(false);
        // setDisableBtn(true);
    };

    const weightGainData = (
        prePregnancyWeight,
        weightUnit,
        weightId,
        currentWeek,
        currentWeekId,
        isExpectingTwins
    ) => {
        weightGainCalcData = {
            prePregnancyWeight,
            weightUnit,
            weightId,
            currentWeek,
            currentWeekId,
            isExpectingTwins,
        };
        // console.log(weightGainCalcData);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleCalculateWeightGain = (e) => {
        e.preventDefault();
        // set the component to loading
        setWeightGainCalculatorData({
            loader: true,
        });

        let data = {
            Week: weightGainCalcData.currentWeek,
            ExpectedTwin: weightGainCalcData.isExpectingTwins,
            WeightUnitId: weightGainCalcData.weightId,
        };

        let restUrl = CONFIG_OBJECT.WEIGHTGAIN_CALCULATOR_REST_URL;
        postDataFetcher(`${restUrl}${App_Constants.SC_API_KEY}`, data)
            .then((response) => {
                Promise.resolve();
                setWeightGainCalculatorData({
                    showResult: true,
                    apiData: response.data.Data,
                    loader: false, // stop loading
                });
                // console.log(response.data.Data);
                executeScroll();
            })
            .catch((error) => {
                setWeightGainCalculatorData({
                    error: error.response.data.Errors,
                    loader: false,
                });
            });
    }

    return (
        <>
            <section
                className="weight-gain-calc-wrap"
                id="main"
                data-test="component-ovulation"
            >
                <div className="container">
                    {showDesc && (
                        <p className="description">
                            {componentData?.description?.value}
                        </p>
                    )}
                    {/* {showEditForm &&
                        <div className="goals-section container-mobile">
                            <div className="recalculate-wrap-period-form">
                                <div className="container">
                                    <div className="fdlp-mobile">
                                        <span>{componentData?.PrepregnacyWeightLabel?.value}</span><span style={{ 'textTransform': 'capitalize' }}>{weightData.prePregnancyWeight.toLocaleLowerCase()} {unit}</span>
                                    </div>
                                    <div className="cycle-length-mobile">
                                        <span>{componentData.parentOneTitle.value}</span><span>{weightData.motherHeight} {unit}</span>
                                    </div>
                                    <div className="cycle-length-mobile">
                                        <span>{componentData.parentOneTitle.value}</span><span>{heightData.fatherHeight} {unit}</span>
                                    </div>
                                    <button onClick={showMainMenu}>
                                        <img src="https://dev1.v2.wemshowcase.com/-/media/JssReactWeb/data/media/img/Common/red_pencil.ashx?h=15&amp;w=15&amp;hash=CA6D8D1AE479F86ACEBAF8CBC007C43D" />
                                        <span>Edit</span>
                                    </button>
                                </div>
                            </div>
                        </div> } */}
                    <div className="form-container">
                        <form onSubmit={handleSubmit} noValidate>
                            <WeightGainCalculatorForm
                                componentData={componentData}
                                weightGainData={weightGainData}
                            />
                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="mt-3">
                                        <button
                                            id="btn-calculate"
                                            className="calculate"
                                            onClick={(e) =>
                                                handleCalculateWeightGain(e)
                                            }
                                        >
                                            {t(
                                                "WeightGainCalculator_SubmitButton"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        {/* { showForm &&
                            <form role="form" className="form-inline" onSubmit={e => handleSubmit(e)}>
                                <div className="form-section">
                                    <label>{componentData?.PrepregnacyWeightLabel?.value}</label>
                                    <input type="number" value={weight} onChange={(e) => setWeight(e.target.value)} placeholder="Enter Weight" />
                                </div>
                                <div className="form-section">
                                    <label>{componentData?.WeekLabel?.value}</label>
                                </div>
                                <div className="form-section">3</div>
                                <div className="form-section">4</div>
                            </form> } */}
                    </div>
                </div>
                <hr className="form-divider" />
                <div className="container">
                    <div className="resultblk" ref={resultRef}>
                        {WeightGainCalculatorData.loader && <Loader />}
                        {WeightGainCalculatorData.showResult && (
                            <WeightGainCalculatorResult
                                componentData={componentData}
                                WeightGainCalculatorData={WeightGainCalculatorData}
                            />
                        )}
                    </div>
                </div>
                <div className="calculator-note-section">
                    <p>
                        Note: Please note that the result is a prediction and
                        not necessarily 100% accurate.
                    </p>
                </div>
            </section>
        </>
    );
};

export default withTranslation()(WeightGainCalculator);
